/* global bocAmchart, AmCharts */

/**
 * Get the list of guides and labels from the shortcode and add all the guides to the chart
 *
 * @param {array} fromShortcode Array of parameters taken from the shortcode
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @return {void}
 */
bocAmchart.setGuidesFromShortcode = function (fromShortcode, chartSettings) {
    var i = 0;
    var hasMoreData = true;

    // Back up the defined guides for possible overrides
    var guidesFromJs;
    if (chartSettings.hasOwnProperty('guides')) {
        guidesFromJs = chartSettings.guides;
    }
    chartSettings.guides = [];

    while (hasMoreData) {
        if (fromShortcode.hasOwnProperty('guide' + i + 'start')) {

            var thisLabel = '';
            if (fromShortcode.hasOwnProperty('guide' + i + 'label')) {
                thisLabel = fromShortcode['guide' + i + 'label'];
                if (fromShortcode.hasOwnProperty('guide' + i + 'labelwidth')) {
                    thisLabel = bocAmchart.wrapText(
                        thisLabel,
                        parseInt(fromShortcode['guide' + i + 'labelwidth'])
                    );
                }
            }

            var thisStart = '';
            if (fromShortcode.hasOwnProperty('guide' + i + 'start')) {
                thisStart = fromShortcode['guide' + i + 'start'];
            }

            var thisEnd = '';
            if (fromShortcode.hasOwnProperty('guide' + i + 'end')) {
                thisEnd = fromShortcode['guide' + i + 'end'];
            }

            var thisAxis = '';
            if (fromShortcode.hasOwnProperty('guide' + i + 'axis')) {
                thisAxis = fromShortcode['guide' + i + 'axis'];
            }

            var guide = {
                'id': 'g' + i,
                'label': thisLabel,
                'boldLabel': false,
                'tickLength': 0,
                'lineColor': AmCharts.themes[chartSettings.bocSettings.theme].AmCoordinateChart.colors[30]
            };

            if (fromShortcode.hasOwnProperty('guide' + i + 'labelshiftx')) {
                guide.shiftX = parseInt(fromShortcode['guide' + i + 'labelshiftx']);
            }
            if (fromShortcode.hasOwnProperty('guide' + i + 'labelshifty')) {
                guide.shiftY = parseInt(fromShortcode['guide' + i + 'labelshifty']);
            }

            bocAmchart.initChartVars(chartSettings);
            bocAmchart.vars[chartSettings.bocSettings.id].guides = bocAmchart.vars[chartSettings.bocSettings.id].guides || [];
            bocAmchart.vars[chartSettings.bocSettings.id].guides.push(guide);

            var isDateCategory = (thisAxis === '') && chartSettings.categoryField === "date";

            if (isDateCategory) {
                guide.date = new Date(thisStart);
                guide.date.setHours(guide.date.getHours() + 16);
            } else {
                if (thisAxis) {
                    guide.value = thisStart;
                } else {
                    guide.category = thisStart;
                }
            }

            if (thisAxis) {
                guide.valueAxis = thisAxis;
            }

            if (thisEnd) {
                guide.fillAlpha = 0.1;
                if (isDateCategory) {
                    guide.toDate = new Date(thisEnd);
                    guide.toDate.setHours(guide.toDate.getHours() + 16);
                    guide.position = 'bottom';
                } else {
                    if (thisAxis) {
                        guide.toValue = thisEnd;
                        guide.position = 'top';
                    } else {
                        guide.toCategory = thisEnd;
                        guide.expand = true;
                        guide.position = 'left';
                    }
                }
                guide.inside = true;
            } else {
                guide.lineAlpha = 0.9;
                guide.lineColor = AmCharts.themes[chartSettings.bocSettings.theme].AmCoordinateChart.colors[30];
                guide.lineThickness = 1;
                if (thisAxis === '') {
                    guide.position = 'top';
                    guide.inside = false;
                } else {
                    guide.position = 'left';
                    guide.inside = true;
                }

            }

            // Check if chart config had per guide settings to apply/override defaults
            if (Array.isArray(guidesFromJs)) {
                guidesFromJs.forEach(function (perGuideOverride) {
                    if (perGuideOverride.hasOwnProperty("id") && perGuideOverride.id === ("g" + i)) {
                        for (var guideProp in perGuideOverride) {
                            if (guideProp !== "id" && perGuideOverride.hasOwnProperty(guideProp)) {
                                guide[guideProp] = perGuideOverride[guideProp];
                            }
                        }
                    }
                });
            }


            if (bocAmchart.debug(chartSettings)) {
                // eslint-disable-next-line no-console
                console.log(
                    chartSettings.bocSettings.id,
                    "Adding guide from shortcode:",
                    bocAmchart.debugClone(guide),
                    "Shortcode:",
                    fromShortcode
                );
            }

            chartSettings.guides.push(guide);
        } else {
            hasMoreData = false;
        }
        i++;
    }

    if (i > 1) {
        chartSettings.listeners.push({
            event: 'zoomed',
            method: bocAmchart.adjustGuideLabels
        });

        chartSettings.listeners.push({
            event: 'drawn',
            method: bocAmchart.adjustGuideLabels
        });

        bocAmchart.vars[chartSettings.bocSettings.id].firstRun = true;
    }
};

/**
 * Shift the guide labels based on the custom parameters.
 * @param {object} event for the redraw
 * @returns {void}
 */
bocAmchart.adjustGuideLabels = function (event) {

    // On first run, the zoom and drawn both happen, so avoid adjusting the position twice
    if (event.type === 'zoomed' && bocAmchart.vars[event.chart.bocSettings.id].firstRun) {
        bocAmchart.vars[event.chart.bocSettings.id].firstRun = false;
        return;
    }
    bocAmchart.vars[event.chart.bocSettings.id].guides.forEach(function (guide) {
        var lineCount = guide.label.split("\n").length;

        var $label = jQuery(
            '#' + event.chart.bocSettings.id + ' .amcharts-axis-label.amcharts-guide-' + guide.id
        );
        var shiftY = guide.shiftY || 0;
        $label.find('tspan').each(function () {
            var $this = jQuery(this);
            $this.attr('y', $this.attr('y') - 12 * (lineCount - 1) + shiftY);
            if (guide.shiftX) {
                $this.attr('x', parseInt($this.attr('x')) + guide.shiftX);
            }
        });

    });
};

/**
 * Defines series of functions to be used in Amcharts to force-wrap the labels in different contexts
 * @returns {string} wrapped label
 */
var labelWrapSizes = [30, 20, 10, 5];
labelWrapSizes.forEach(function (size) {
    bocAmchart['wrapText' + size] = function (data, label) {
        return bocAmchart.wrapText(label, size);
    };
    bocAmchart['wrapCategoryLabel' + size] = function (label) {
        return bocAmchart.wrapText(label, size);
    };
});

/**
 * Function to wrap the label
 * @param {string} label original
 * @param {int} maxWidth in characters
 * @returns {string} Wrapped label
 */
bocAmchart.wrapText = function (label, maxWidth) {
    label = label.replace("-", "- ");
    var parts = label.split(' ');
    var lineLength = 0;
    var output = '';
    var separator = "\n";
    parts.forEach(function (part, idx) {
        if (idx === parts.length - 1) {
            separator = "";
        }
        if (lineLength === 0 && part.length >= maxWidth) {
            output += part + separator;
        } else if (lineLength >= 0 && (part.length + lineLength) < maxWidth) {
            output += " " + part;
            lineLength += part.length;
        } else if (lineLength > 0 && (part.length + lineLength) >= maxWidth) {
            output += " " + part + separator;
            lineLength = 0;
        }
    });
    return output;
};
